module.exports = __webpack_public_path__ + "img/new_realpleyer04.e06deebf.png";